export default {
  'custom.lists.title': 'Lists',
  'custom.lists.tab.groups': 'Groups',
  'custom.lists.tab.favorites': 'Favorites',
  'custom.lists.text.created': 'The item has been created successfully.',
  'custom.lists.text.removed': 'The item has been removed successfully.',
  'custom.lists.text.edited': 'The item has been updated successfully.',
  'custom.lists.text.listGroups': 'List Groups',
  'custom.lists.text.listEntityGroups': 'Dynamic Entity Groups',

  'custom.lists.text.type': 'Type',
  'custom.lists.text.cliente': 'Client',
  'custom.lists.text.direccion': 'Address',
  'custom.lists.text.distrito': 'District',
  'custom.lists.text.completed': 'Completed',

  'customList.text.detail': 'Details',
  'customList.text.cancel': 'Cancel',
  'customList.text.complete': 'Complete',
  'customList.text.approve': 'Approve',
  'customList.text.reject': 'Reject',
  'customList.text.execute': 'Execute',
  'customList.text.sign': 'Sign',
  'customList.text.reassign': 'Reassign',

  'custom.lists.text.message.cancel': 'The item has been canceled successfully',
  'custom.lists.text.message.approve': 'The item has been approved successfully',
  'custom.lists.text.message.execute': 'The item has been executed successfully',
  'custom.lists.text.message.sign': 'The item has been signed successfully',
  'custom.lists.text.message.reassign': 'The item has been reassigned successfully',
};
